
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/articles/movies2watch-movies-apps",
      function () {
        return require("private-next-pages/articles/movies2watch-movies-apps.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/articles/movies2watch-movies-apps"])
      });
    }
  